export default __webpack_public_path__ + "static/media/TW.c83660b6.ico";